export const theme = {
  colors: {
    primary: "#FFD200",
    primaryLight: "#FFE04D",
    primaryDark: "#CCAA00",
    primaryTransparent: "var(--davey-primary-transparent)",
    onPrimary: "#000000",
    onTertiary: "#FFFFFF",

    secondary: "#000000",
    secondaryLight: "#333333",
    secondaryTransparent: "var(--davey-secondary-transparent)",

    tertiary: "#00747A",
    tertiaryLight: "#3D9DA2",
    tertiaryPale: "var(--davey-tertiary-pale)",
    tertiaryDark: "#005B5F",
    tertiaryTransparent: "var(--davey-tertiary-transparent)",

    white: "#FFFFFF",
    black: "#000000",
    grey: "var(--davey-grey)",
    lightGrey: "var(--davey-light-grey)",
    darkGrey: "var(--davey-dark-grey)",

    error: "#DC3545",
    success: "#28A745",
    warning: "#FFC107",

    bgLight: "var(--davey-bg-light)",
    bgLighter: "var(--davey-bg-lighter)",
    surface: "var(--davey-surface)",
    onSurface: "var(--davey-on-surface)",
    border: "var(--davey-border)",
    borderLight: "var(--davey-border-light)",
    textPrimary: "var(--davey-text)",
    textSecondary: "var(--davey-text-secondary)",
    textMuted: "var(--davey-text-muted)",
    infoLight: "var(--davey-info-light)",
    infoDark: "#0288D1",
    focusRing: "var(--davey-focus-ring)",
    warningBg: "var(--davey-warning-bg)",
    warningText: "var(--davey-warning-text)",
    successBg: "var(--davey-success-bg)",
    errorBg: "var(--davey-error-bg)",

    statusActive: "var(--davey-status-active)",
    statusActiveText: "var(--davey-status-active-text)",
    statusInactive: "var(--davey-status-inactive)",
    statusInactiveText: "var(--davey-status-inactive-text)",

    chart: {
      yellow: "#FFD200",
      yellowLight: "#FFE04D",
      teal: "#3D9DA2",
      tealLight: "#A8D5D8",
      tealDark: "#005B5F",
      blue: "#5DADE2",
      amber: "#F39C12",
      emerald: "#48C9B0",
      grey: "#B3B3B3",
    },
  },
  fonts: {
    primary:
      "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    code: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
  },
  breakpoints: {
    mobile: "480px",
    tablet: "768px",
    laptop: "1024px",
    desktop: "1200px",
  },
  fontSizes: {
    small: "0.875rem",
    regular: "1rem",
    medium: "1.25rem",
    large: "1.5rem",
    xlarge: "2rem",
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    bold: 700,
  },
  borderRadius: {
    small: "4px",
    medium: "8px",
    large: "12px",
  },
  shadows: {
    small: "var(--davey-shadow-small)",
    medium: "var(--davey-shadow-medium)",
    large: "var(--davey-shadow-large)",
  },
};

export type ThemeType = typeof theme;
